import request from './request.js'

export function sendAnalytics(name, session_id, site) {
    request('https://api-dev-readloud.apptimizm.pro/api/v1/analytics/send-statistics/', 'POST', { name, session_id, site, url: window.location.pathname })
}